import React, { useEffect } from 'react';
import { Grid, Card, CardContent, Typography, Table, TableBody, TableCell, TableHead, TableRow, Paper, Box, Select, MenuItem, FormControl } from '@mui/material';
import { Chart, ArcElement, Tooltip } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import axiosInstance from '../../axios/axios';
import { useState } from 'react';
import moment from 'moment';

// Register chart.js components
Chart.register(ArcElement, Tooltip);

const Dashboard = () => {

  const [topProducts, settopProducts] = useState([])
  const [mostsold, setMostSold] = useState([])
  const [renewal, setRenewal] = useState([])
  const [licensecount, setlicensecount] = useState([])
  const [nooflicense, setnooflicense] = useState(0)
  const [noofClient, setnoofclient] = useState(0)
  const [noofproduct, setnoofproduct] = useState(0)
  const [products, setProducts] = useState([]);
  const [productName, setProductName] = useState(0)
  const getProductList = async () => {
    const response = await axiosInstance.post('/product/List')
    const { success, products } = response.data
    if (success === true) {
      setProducts(products)
    } else {
      setProducts([])
    }
  }
  useEffect(() => {

    getProductList()
  }, [])
  useEffect(() => {
    const req = {
      productName: productName
    }
    const getdashboardData = async () => {
      const response = await axiosInstance.post('/dashboard', req)
      const { data, success } = response.data
      if (success === true) {
        settopProducts(data?.topSellingProducts)
        setMostSold(data?.mostSoldProduct)
        setRenewal(data?.renewalLicenseAlert)
        const licenseCounts = [
          data.activeLicenses[0]?.activeCount || 0, // Get activeCount, default to 0 if undefined
          data.inactiveLicenses[0]?.inactiveCount || 0, // Get inactiveCount, default to 0 if undefined
        ];
        setnoofproduct(data?.noOfProducts[0].productCount)
        setnoofclient(data?.noOfClients[0].clientCount)
        setlicensecount(licenseCounts)
        setnooflicense(data?.noOfLicenses[0].licenseCount)
      }
    }
    getdashboardData()
  }, [productName])
  const pieData = {
    labels: ['Active Licenses', 'Inactive Licenses'],
    datasets: [
      {
        data: licensecount,
        backgroundColor: ['#2563EB', '#C084FC'], // Updated colors
      },
    ],
  };
  // User data
  const activePercentage = licensecount?.[0];
  const inactivePercentage = licensecount?.[1];


  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <Grid container spacing={2}>

          {
            [{ title: 'No. of Clients', value: `${noofClient}`, color: '#CB01BD', bg: '#e59edb80' },
            { title: 'No. of Products', value: `${noofproduct}`, color: '#5C3685', bg: '#c09ce780' },
            { title: 'No. of Purchases', value: `${nooflicense}`, color: '#2EAEA4', bg: '#b6f7f280' },
            { title: 'No. of Licenses', value: `${nooflicense}`, color: '#A37A2B', bg: '#e1bd7d80' },].map((card, index) => (
              <Grid item xs={6} key={index}>
                <Card
                  sx={{
                    // Set consistent height
                    borderRadius: '10px',
                    border: `2px solid ${card.color}80`,
                    background: card.bg,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                  }}
                >
                  <CardContent>
                    <Typography
                      sx={{
                        fontFamily: 'Times New Roman',
                        fontWeight: 700,
                        fontSize: '24px',
                        color: card.color,
                      }}
                    >
                      {card.title}
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: 'Times New Roman',
                        fontWeight: 700,
                        fontSize: '40px',
                        color: card.color,
                      }}
                    >
                      {card.value}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
        </Grid>
      </Grid>

      {/* Second Column with Doughnut Chart */}
      <Grid item xs={4}>
        <Card sx={{ height: 300 }}> {/* Set consistent height */}
          <CardContent>
            <Typography
              sx={{
                fontFamily: 'Times New Roman',
                fontWeight: 700,
                fontSize: '24px',
                lineHeight: '27.6px',
                color: '#646464',
              }}
              gutterBottom
            >
              Active / Inactive License Chart
            </Typography>
            <Grid container alignItems="center" spacing={2} style={{ height: '100%' }}>
              {/* Left Section: Text and Indicators */}
              <Grid item xs={6}>
                <Box display="flex" alignItems="center" mb={1}>
                  <Box width={12} height={12} bgcolor="#2563EB" mr={1} />
                  <Typography variant="body2">Active Licenses: {activePercentage}% ({licensecount?.[0]})</Typography>
                </Box>
                <Box display="flex" alignItems="center">
                  <Box width={12} height={12} bgcolor="#C084FC" mr={1} />
                  <Typography variant="body2">Inactive Licenses: {inactivePercentage}% ({licensecount?.[1]})</Typography>
                </Box>
              </Grid>

              {/* Right Section: Smaller Doughnut Chart */}
              <Grid item xs={6} display="flex" justifyContent="center" alignItems="center">
                <Doughnut
                  data={pieData}
                  options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    cutout: '50%', // Makes the doughnut smaller
                  }}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={4}>
        <Card sx={{ padding: 0, margin: 0, height: 300 }}>
          <CardContent sx={{ padding: '0 !important' }}>
            {/* Remove default padding */}
            <Typography
              sx={{
                fontFamily: 'Times New Roman',
                fontWeight: 700,
                fontSize: '24px',
                lineHeight: '27.6px',
                color: '#646464',
                padding: 2, // Add some padding to the title only
              }}
            >
              Top Selling Products
            </Typography>

            <Box
              sx={{
                maxHeight: 200, // Adjust height for the scrollable area
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch', // Smooth scrolling for iOS
                '&::-webkit-scrollbar': {
                  display: 'none', // Hide scrollbar for Webkit browsers
                },
                msOverflowStyle: 'none', // Hide scrollbar for Internet Explorer
                scrollbarWidth: 'none', // Hide scrollbar for Firefox
              }}
            >
              <Table sx={{ width: '100%' }}>
                <TableHead sx={{ background: '#EEDEFF' }}>
                  <TableRow>
                    <TableCell
                      sx={{ fontFamily: 'Times New Roman', fontSize: '16px', fontWeight: 700 }}
                    >
                      Product
                    </TableCell>
                    <TableCell
                      sx={{ fontFamily: 'Times New Roman', fontSize: '16px', fontWeight: 700 }}
                    >
                      Sales
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {topProducts.map((product, index) => (
                    <TableRow
                      key={product.id}
                      sx={{
                        backgroundColor: index % 2 === 0 ? '#F6F6F6' : '#D7D7D7', // Alternate row colors
                      }}
                    >
                      <TableCell
                        sx={{
                          fontFamily: 'Times New Roman',
                          fontSize: '16px',
                          fontWeight: 400,
                          lineHeight: '18.4px',
                          textAlign: 'left',
                        }}
                      >
                        {product.PD_Name}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: 'Times New Roman',
                          fontSize: '16px',
                          fontWeight: 400,
                          lineHeight: '18.4px',
                          textAlign: 'left',
                        }}
                      >
                        {product.salesCount}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={6}>
        <Card sx={{ padding: 0, margin: 0, height: 300 }}>
          <CardContent sx={{ padding: '0 !important' }}>
            {/* Title */}
            <Typography
              sx={{
                fontFamily: 'Times New Roman',
                fontWeight: 700,
                fontSize: '24px',
                lineHeight: '27.6px',
                color: '#646464',
                padding: 2,
              }}
            >
              Most Sold Products
            </Typography>

            {/* Product Select Box */}
            <FormControl
              sx={{
                margin: 2, // Add margin to the FormControl
                minWidth: 200, // Minimum width for the select box
                //  display: 'flex',        // Make the FormControl a flex container
                // alignSelf: 'flex-end',  // Align to the right side of the parent container
                // justifyContent: 'flex-end',
              }}
              size="small" // Smaller size for compact appearance
            >
              <Select
                labelId="product-select-label"
                id="product-select"
                value={productName}
                onChange={(e) => setProductName(e.target.value)}
              >
                <MenuItem value={0} selected>
                  All
                </MenuItem>
                {products &&
                  products.map((product) => (
                    <MenuItem key={product.PD_Id} value={product.PD_Id}>
                      {product.PD_Name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>

            {/* Scrollable Table */}
            <div
              style={{
                maxHeight: '200px',
                overflowY: 'scroll',
                scrollbarWidth: 'none',
              }}
            >
              <style>
                {`
            div::-webkit-scrollbar {
              display: none;
            }
          `}
              </style>
              <Table sx={{ width: '100%' }}>
                <TableHead sx={{ background: '#EEDEFF' }}>
                  <TableRow>
                    <TableCell
                      sx={{
                        fontFamily: 'Times New Roman',
                        fontSize: '16px',
                        fontWeight: 700,
                      }}
                    >
                      Product
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: 'Times New Roman',
                        fontSize: '16px',
                        fontWeight: 700,
                      }}
                    >
                      Sales
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {mostsold &&
                    mostsold.map((product, index) => (
                      <TableRow
                        key={product.id}
                        sx={{
                          backgroundColor: index % 2 === 0 ? '#F6F6F6' : '#D7D7D7',
                        }}
                      >
                        <TableCell
                          sx={{
                            fontFamily: 'Times New Roman',
                            fontSize: '16px',
                            fontWeight: 400,
                            lineHeight: '18.4px',
                            textAlign: 'left',
                          }}
                        >
                          {product.PD_Name}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontFamily: 'Times New Roman',
                            fontSize: '16px',
                            fontWeight: 400,
                            lineHeight: '18.4px',
                            textAlign: 'left',
                          }}
                        >
                          {product.salesCount}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </div>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={6}>
        <Card sx={{ padding: 0, margin: 0, height: 300 }}>
          <CardContent sx={{ padding: '0 !important', height: '100%' }}> {/* Ensure content fills the height */}
            <Typography
              sx={{
                fontFamily: 'Times New Roman',
                fontWeight: 700,
                fontSize: '24px',
                lineHeight: '27.6px',
                color: '#646464',
                padding: 2, // Add some padding to the title only
              }}
            >
              Renewal Alert
            </Typography>

            <Box
              sx={{
                overflowY: 'auto',
                height: 'calc(100% - 56px)', // Adjust height to accommodate Typography height
                '&::-webkit-scrollbar': {
                  display: 'none', // Hide scrollbar for webkit browsers
                },
                '-ms-overflow-style': 'none', // Hide scrollbar for IE and Edge
                'scrollbar-width': 'none', // Hide scrollbar for Firefox
              }}
            >
              <Table sx={{ width: '100%' }}>
                <TableHead sx={{ background: '#EEDEFF' }}>
                  <TableRow>
                    <TableCell sx={{ fontFamily: 'Times New Roman', fontSize: '16px', fontWeight: 700 }}>Client</TableCell>
                    <TableCell sx={{ fontFamily: 'Times New Roman', fontSize: '16px', fontWeight: 700 }}>Product</TableCell>
                    <TableCell sx={{ fontFamily: 'Times New Roman', fontSize: '16px', fontWeight: 700 }}>Expiry Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {renewal && renewal.map((product, index) => (
                    <TableRow
                      key={product.id}
                      sx={{
                        backgroundColor: index % 2 === 0 ? '#F6F6F6' : '#D7D7D7', // Alternate row colors
                      }}
                    >
                      <TableCell
                        sx={{
                          fontFamily: 'Times New Roman',
                          fontSize: '16px',
                          fontWeight: 400,
                          lineHeight: '18.4px',
                          textAlign: 'left',
                        }}
                      >
                        {product.clientName}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: 'Times New Roman',
                          fontSize: '16px',
                          fontWeight: 400,
                          lineHeight: '18.4px',
                          textAlign: 'left',
                        }}
                      >
                        {product.productName}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: 'Times New Roman',
                          fontSize: '16px',
                          fontWeight: 400,
                          lineHeight: '18.4px',
                          textAlign: 'left',
                        }}
                      >
                        {moment(product.LD_ExpiryDate).format('DD-MM-YYYY')}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </CardContent>
        </Card>
      </Grid>

    </Grid>
  );
};

export default Dashboard;
